import { CFTokens } from '../../../../tokens';
export const ICON_COLOR = CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT;
export const ICON_SIZE = 24;
